
export default function About() {
  const stats = [
    { number: '15+', label: 'Years Experience' },
    { number: '200+', label: 'Projects Completed' },
    { number: '50+', label: 'Happy Clients' },
    { number: '24/7', label: 'Support Available' }
  ];

  return (
    <section id="about" className="py-20 bg-stone-50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-4xl font-bold text-gray-800 mb-4">About Vine Consulting Engineers</h2>
            <p className="text-lg text-gray-600 mb-4 leading-relaxed">
              Vine Consulting Engineers provides civil engineering design and advisory services for the residential construction sector.
            </p>
            <p className="text-lg text-gray-600 mb-4 leading-relaxed">
              Our work is focused on delivering practical, buildable, and compliant solutions that meet regulatory requirements, optimise cost efficiency, consider project requirements, and address health and safety obligations under CDM.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We support our clients throughout the project lifecycle, providing technical guidance, coordination, and independent review to ensure projects are delivered safely, reliably, and efficiently.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center bg-white px-4 py-2 rounded-lg border border-stone-200">
                <i className="ri-award-line text-emerald-600 mr-2"></i>
                <span className="text-sm font-medium text-gray-700">SMAS Approved</span>
              </div>
              <div className="flex items-center bg-white px-4 py-2 rounded-lg border border-stone-200">
                <i className="ri-shield-check-line text-emerald-600 mr-2"></i>
                <span className="text-sm font-medium text-gray-700">Fully Insured</span>
              </div>
              <div className="flex items-center bg-white px-4 py-2 rounded-lg border border-stone-200">
                <i className="ri-time-line text-emerald-600 mr-2"></i>
                <span className="text-sm font-medium text-gray-700">On-Time Delivery</span>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/25bd6a9c0c5cf960313d03e8d1447d98/01c24215706bfe9c2b7635ccdb053546.png"
              alt="Vine Consulting Engineers Team"
              className="rounded-xl shadow-lg object-cover w-full h-96"
            />
          </div>
        </div>

        {/* SMAS Logo */}
        <div className="flex justify-center items-center gap-12">
          <img 
            src="https://public.readdy.ai/ai/img_res/38e223c8-f745-4c9b-965c-02de184a5576.png"
            alt="SMAS Worksafe"
            className="h-20 object-contain"
          />
          <img 
            src="https://public.readdy.ai/ai/img_res/c2d6a478-7672-4a6c-a7cb-e84adb251f53.png"
            alt="SSIP Accredited"
            className="h-20 object-contain"
          />
        </div>
      </div>
    </section>
  );
}
